export default __webpack_public_path__ + "97e79e096e72319a4568443f8e67719a.png";